/**
 * En-tête d'association — libellés et URL du logo, DÉFINITION UNIQUE.
 *
 * `AssociationsPageHeader` est monté par la page de l'association ET par ses
 * cinq pages « tout lister » (billetterie, cagnottes, adhésions, boutiques,
 * QR codes). Karim 2026-09-12 : « exactement pareil ». Or il reçoit ses
 * libellés et son fabricant d'URL en props : recopiés d'un écran à l'autre,
 * ils auraient fini par diverger — une catégorie ajoutée ici, oubliée là.
 */
import { ANCIENNES_CATEGORIES, THEMES } from "@donoor/utils";
import { associationAffichee } from "~/utils/themesAffiches";

/**
 * Ce qu'on écrit sous le nom de l'association, selon son thème, DANS LA
 * LANGUE DE LA PAGE (`associationAffichee`, utils/themesAffiches.ts). Couvre
 * aussi les ANCIENNES valeurs (« cultuelle », « sportive »…) : une page mise
 * en cache ou une donnée pas encore migrée reste lisible. Fonction (et non
 * constante) : la langue est lue à l'appel.
 */
export function libellesCategorieAsso(): Record<string, string> {
  return Object.fromEntries(
    [...THEMES.map((t) => t.key), ...Object.keys(ANCIENNES_CATEGORIES)].map((k) => [
      k,
      associationAffichee(k),
    ]),
  );
}
/**
 * Logo de l'association, en « contain » — un logo ne se recadre pas, il se
 * pose en entier dans sa pastille. Servi en 240×240 : la pastille fait
 * jusqu'à 120 px, net sur écran Retina.
 */
export function urlLogoAsso(
  assetsUrl: string,
): (fileId: string | null) => string | null {
  return (fileId) =>
    fileId
      ? `${assetsUrl}/${fileId}?width=240&height=240&fit=contain&format=webp&quality=80`
      : null;
}
